import { cssVariablesFor } from './tokens';

/**
 * Status tones, as references to the CSS custom properties `applyThemeTokens` writes.
 *
 * Referencing the VARIABLE rather than the value is what makes a status dot follow the
 * theme without the component knowing which theme it is in — the same indirection
 * `styles/index.css` uses, and the reason a `ThemeScope` can render a light card inside a
 * dark app and have the dots come out right.
 */
export type StatusTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export const TONE_VAR: Record<StatusTone, string> = {
  success: 'var(--success)',
  warning: 'var(--warning)',
  danger: 'var(--destructive)',
  info: 'var(--info)',
  neutral: 'var(--muted-foreground)',
};

/** The tripwire for renaming a token out from under the tones. */
export const toneVariableNames = (): string[] =>
  Object.values(TONE_VAR).map((reference) => reference.slice('var('.length, -1));

export const toneVariablesResolve = (): boolean => {
  const declared = new Set(Object.keys(cssVariablesFor('light')));
  return toneVariableNames().every((name) => declared.has(name));
};
